












































































































































import {
  Component,
  Emit,
  Inject,
  Model,
  Prop,
  Provide,
  Vue,
  Watch
} from "vue-property-decorator";
import { State, Getter, Action, Mutation, namespace } from "vuex-class";
import UserInfo from "@/components/userInfo/userInfo.vue";
import ScrollView from "@/components/scroll/flipScroll.vue";
import * as types from "@/store/constants/types";
import lazyLoad from "@/components/lazyLoad/lazyLoad.vue";
// import CoinEntrance from "@/components/coinEntrance/coinEntrance.vue";
import SkuSection from "@/components/sku/skuSection.vue";
import Tab from "@/components/tab/Tab.vue";
import TabContent from "@/components/tab/TabContent.vue";
import insMediaGallery from "@/components/popGallery/InsMediaPopGallery.vue";
import insUserGallery from "@/components/popGallery/InsUserPopGallery.vue";
import GeneralUtilsHelper from "@/utils/generalUtils";
import { sendEvent } from "@/utils/analytics";
import { swiperSlide } from "vue-awesome-swiper";
import Swiper from "@/components/swiper/Swiper.vue";
import CoinsTitleSeperator from "@/components/sku/coinsTitleSperator.vue";
import { CDN_BASE_URL } from "@/config/config";
// import EntranceBanner from "@/components/entranceBanner/EntranceBanner.vue";
// import SubsEntranceList from "@/components/entranceBanner/SubsEntranceList.vue";
@Component({
  components: {
    insMediaGallery, //改为同步加载
    insUserGallery,
    Tab,
    TabContent,
    UserInfo,
    ScrollView,
    lazyLoad,
    // CoinEntrance,
    CoinsTitleSeperator,
    SkuSection,
    Swiper,
    swiperSlide,
    SubsEntranceList: () =>
      import("@/components/entranceBanner/SubsEntranceList.vue"),
    EntranceBanner: () =>
      import("@/components/entranceBanner/EntranceBanner.vue"),
    SpecialOffer: () => import("@/components/specialOffer/SpecialOffer.vue"),
    BottomInfo: () => import("@/components/other/bottomInfo.vue"),
    SuperPaySkuEntrance: () =>
      import("@/components/superPayEntrance/SuperPaySkuEntrance.vue")
  },
  name: "PostContainer"
})
export default class PostContainer extends Vue {
  @Getter(types.GETTER_CURRENT_INS_MEDIA_INFO) private getCurrentMediaInfo: any;
  @Getter(types.GETTER_CURRENT_INS_USER_ID) private currentUserId: any;
  @Getter(types.GETTER_CURRENT_INS_MEDIA_LIST_INFO)
  private getCurrentMediaListInfo: any;
  @Action(types.UPDATE_USER_INS_POST) private updateUserInsPost: any;
  @Getter(types.GETTER_CURRENT_INS_USER_INFO) private currentUserInfo: any;
  @Action(types.ROUTER_PUSH) private routerPush: any;
  @Action(types.SHOW_LITE_SEARCH_OR_LOGIN) private showLoginOrSearch: any;

  private insMediaGalleryShow: boolean = false; //弹出的Gallery显示或隐藏
  private insUserGalleryShow: boolean = false;
  private tabsArractiveIndex: number = 0;
  private subsEntranceShow: boolean = true;

  private specialOfferForceShow: boolean = false; //是否从通知进入

  private tabsArr: object[] = [
    {
      label: "Likes",
      labelColor: "rgb(255,59,48)",
      imgUrl: CDN_BASE_URL.img + "/tab/icon_likes2.png"
    },
    {
      label: "Comments",
      labelColor: "rgb(23,195,150)",
      imgUrl: CDN_BASE_URL.img + "/tab/icon_comments2.png"
    },
    {
      label: "Views",
      labelColor: "rgb(88,86,214)",
      imgUrl: CDN_BASE_URL.img + "/tab/icon_views2.png"
    }
  ];

  @Watch("getCurrentMediaListInfo", { immediate: true })
  private getCurrentMediaListInfoChange(val: any, oldVal: any) {
    if (val && val.hasOwnProperty("dataStatus") && val.dataStatus !== "ready") {
      console.log("watch到Meida不是准备状态，更新Media信息>>>", {
        val,
        oldVal
      });
      this.updateUserInsPost(this.currentUserId)
        .then((result: any) => {})
        .catch(() => {});
    }
  }

  @Watch("$route", { immediate: true })
  private watchRoute(to: any, from: any) {
    const comeFromNotice = to.params.comeFromNotice;
    if (
      comeFromNotice &&
      (comeFromNotice === true || comeFromNotice === "true")
    ) {
      //表示点击通知进入，强制显示special offer ，并且强制显示 like;
      this.tabsArractiveIndex = 0;
      this.specialOfferForceShow = true;
    }
  }

  get currentType() {
    switch (this.tabsArractiveIndex) {
      case 0:
        return "like";
      case 1:
        return "comment";
      case 2:
        return "view";
      default:
        break;
    }
  }

  get getCurrentMediaInfoData() {
    if (this.tabsArractiveIndex === 2) {
      return this.getCurrentMediaInfo("view");
    } else {
      return this.getCurrentMediaInfo("post");
    }
  }

  get isEmptyAccount() {
    return GeneralUtilsHelper.isEmptyAccount();
  }

  private onPullingDown(done: any) {
    if (!this.isEmptyAccount) {
      this.updateUserInsPost(this.currentUserId)
        .then((result: any) => {
          done();
        })
        .catch(() => {
          done();
        });
    } else {
      done();
    }
  }

  private clickUserInfo() {
    if (this.isEmptyAccount) {
      this.showLoginOrSearch();
    } else {
      this.insMediaGalleryShow = true;
    }
  }

  private specialOfferShowOrHideTimer(val: boolean) {
    console.log("specialOfferShowOrHideTimer:", val);
    if (val) {
      //显示
      this.subsEntranceShow = false;
    } else {
      //隐藏
      this.subsEntranceShow = true;
    }
  }

  private clickChangeUserPop() {
    console.log("clickChangeUserPop");
    this.insUserGalleryShow = true;
    this.insMediaGalleryShow = false;
  }

  private clickUserItem() {
    this.insMediaGalleryShow = true;
  }

  private slideChange(index: any) {
    this.tabsArractiveIndex = index;
  }
  private mounted() {
    console.log("post页面ounted");
  }
  private activated() {
    // console.log("post页面被激活了");
  }
}
